export default __webpack_public_path__ + "static/media/landing-tablet.7c12555a.png";